import React from 'react'

import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Stack from '@mui/material/Stack'

import { Text } from '@mxenabled/mxui'

interface ListItemRowProps {
  onClick?: () => void
  leftIcon?: React.ReactNode
  rightIcon?: React.ReactNode
  title?: string
  subtitle?: string
  rightContent?: React.ReactNode
  titleBold?: boolean
  rightContentBold?: boolean
}

export const ListItemRow: React.FC<ListItemRowProps> = ({
  onClick,
  leftIcon,
  rightIcon,
  title,
  subtitle,
  rightContent,
  titleBold = true,
  rightContentBold = true,
}) => {
  const content = (
    <React.Fragment>
      {leftIcon && <ListItemIcon sx={{ ml: 0 }}>{leftIcon}</ListItemIcon>}
      <ListItemText>
        <Stack
          sx={{
            alignItems: 'center',
            flexDirection: 'row',
            marginLeft: 12,
          }}
        >
          <Stack sx={{ flex: 1, minWidth: 0 }}>
            <Text bold={titleBold} variant="body1">
              {title}
            </Text>
            {subtitle && <Text variant="caption">{subtitle}</Text>}
          </Stack>
          <Stack sx={{ flexDirection: 'row', alignItems: 'center', gap: 1 }}>
            {rightContent && (
              <Text bold={rightContentBold} display="flex" variant="body1">
                {rightContent}
              </Text>
            )}
            {rightIcon && <ListItemIcon>{rightIcon}</ListItemIcon>}
          </Stack>
        </Stack>
      </ListItemText>
    </React.Fragment>
  )

  return (
    <ListItem>
      {onClick ? (
        <ListItemButton
          onClick={onClick}
          sx={{
            py: 14,
          }}
        >
          {content}
        </ListItemButton>
      ) : (
        <Stack
          sx={{
            py: 14,
            px: 24,
            width: '100%',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          {content}
        </Stack>
      )}
    </ListItem>
  )
}
